import React, { FC } from 'react';
import { useAuthContext } from '../AuthProvider';
import { Loading } from '../../_common';
import { Routes } from '../../../utils';
import './Callback.scss';

const Callback: FC = (): React.ReactElement => {
    const { userManager } = useAuthContext();
    
   // debugger;
    userManager.signinRedirectCallback().then(user => {
        if (user) {
            if (window.screen.width > 1199) {
                const redirectUrl: string =
                    window.localStorage.getItem('url') || `${window.location.origin}${Routes.JOB_MANAGEMENT.route}`;
                if (redirectUrl.includes('load_field_op')) {
                    window.location.href = redirectUrl;
                } else window.location.href = `${window.location.origin}${Routes.JOB_MANAGEMENT.route}`;
            } else {
                const redirectUrlTab: string =
                    window.localStorage.getItem('url') ||
                    `${window.location.origin}${Routes.JOB_MANAGEMENT_FOR_TAB.route}`;
                if (redirectUrlTab.includes('load_field_op')) {
                    window.location.href = redirectUrlTab;
                } else window.location.href = `${window.location.origin}${Routes.JOB_MANAGEMENT_FOR_TAB.route}`;
            }
        } else window.location.href = window.location.origin;
    }) .catch(error => {
        console.log("error",error)
       
    });

    return (
        <span className="Callback-Loading">
            <Loading />
        </span>
    );
};

export default Callback;
